import { QueryClient } from 'react-query';
import { FeedType } from '../models';
import { queryKeys } from '../hooks/queryKeyFactory';

export const invalidateFeedQueries = (queryClient: QueryClient): void => {
  queryClient.invalidateQueries(
    queryKeys.fetchArticles.feedByParams({
      take: 1,
      page: 0,
      isMyFeed: true,
      enabled: true,
    })
  );
  queryClient.invalidateQueries(queryKeys.fetchPaginatedArticles.feed(FeedType.My));
  queryClient.invalidateQueries(queryKeys.fetchIssuers.query({ myCS: true }));
  queryClient.invalidateQueries(queryKeys.fetchTopReads.query({ myCS: true }));
};
